<template>
  <div>
  </div>
</template>

<script>
import PaginationService from '@/services/paginationservice'
export default {
  data () {
    return {
      allData: null,
      loader: null,
      isDestroy: false,
      totalRecord: 0,
      localPage: this.currentPage
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    currentPage: {
      type: Number,
      default: 0
    },
    maxRows: {
      type: Number,
      default: 50
    },
    keyword: {
      type: [String, Object],
      default: ''
    },
    method: {
      type: String,
      default: 'get'
    }
  },
  created () {
    this.fetchDataByAPI()
  },
  methods: {
    fetchDataByAPI () {
      if (this.isDestroy) return
      this.loader = this.$loading.show()
      let url = this.url
      let payload = null
      const totalPage = Math.ceil(this.totalRecord / this.maxRows)
      if (totalPage > 0 && this.currentPage > totalPage) {
        this.localPage = 1
      }
      if (this.method === 'get') {
        payload = {
          limit: this.maxRows,
          page: this.localPage,
          ...this.keyword
        }
      } else {
        payload = {
          ...this.keyword
        }
        url = `${url}?page=${this.localPage}&limit=${this.maxRows}`
      }
      const apiMethod = this.method === 'get' ? PaginationService.getData : PaginationService.postDataByExtraUrl
      apiMethod(url, payload)
        .then((response) => {
          if (!response.totalPage || response.totalPage === 0) {
            this.localPage = 0
            this.$emit('updateCurrentPage', 0)
            this.$emit('updateTotalPage', 0)
          } else {
            this.$emit('updateTotalPage', response.totalPage)
          }
          if (this.localPage !== this.currentPage) {
            this.$emit('updateCurrentPage', this.localPage)
          }
          this.$emit('onChangePage', response.data)
          this.totalRecord = response.totalRecord
        })
        .catch((err) => {
          this.$emit('zIndex', 1040)
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
        .finally(() => {
          this.loader && this.loader.hide()
          this.$events.fire('done', this.url)
        })
    },
    fetchDataClient () {

    },
    reload () {
      this.fetchDataByAPI()
    }
  },

  watch: {
    keyword () {
      this.localPage = 1
      this.fetchDataByAPI()
    },
    maxRows () {
      this.fetchDataByAPI()
    },
    currentPage () {
      if (this.localPage !== this.currentPage) {
        this.localPage = this.currentPage
        this.fetchDataByAPI()
      }
    }
  },
  beforeDestroy () {
    this.isDestroy = true
    this.loader && this.loader.hide()
    this.$store.commit('toggleModal')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FetchDataAPI.vue